export default function checkIfCanList({ next, store }) {
  let scopes = store.getters.userScopes;
  if (
    scopes.includes('user_account_list_self') ||
    scopes.includes('user_account_list_company') ||
    scopes.includes('user_account_list_all')
  ) {
    return next();
  }
  return next({
    name: 'settings',
  });
}
